import api from '@/lib/api'
import { ENDPOINTS } from '@/constants/endpoints'

export interface AffiliatedOrganization {
  id: string
  name: string
  category:
    | 'Structure professionnelle'
    | 'Structure scientifique'
    | 'Structure de formation et associative'
  created_at: string
  updated_at: string
}

export interface AffiliatedOrganizationsResponse {
  count: number
  next: string | null
  previous: string | null
  results: AffiliatedOrganization[]
}

export interface AffiliatedOrganizationsParams {
  limit?: number
  offset?: number
  ordering?: string
  search?: string
}

export const affiliatedOrganizationsService = {
  getAffiliatedOrganizations: async (
    params?: AffiliatedOrganizationsParams
  ): Promise<AffiliatedOrganizationsResponse> => {
    const response = await api.get<AffiliatedOrganizationsResponse>(
      ENDPOINTS.AFFILIATED_ORGANIZATIONS.LIST,
      { params }
    )
    return response.data
  },
}
